// React & Libraries
import React from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

// Ant Design
import { Tooltip } from 'antd';
import { UserOutlined } from '@ant-design/icons';

// Helpers
import Helpers from '@Apis/helpers';

// Components
import H3Text from '@Uilib/h3Text';
import ViewCustomFields from '@Components/Common/CustomField/ViewCustomFields';

function ViewPackingSlipDetails({ selectedSO, user, quickUpdateDisable, hasPsEditAccess, quickUpdateSO, getSOById, currentTenantId, currentOrderId, salesOrderType }) {
  return (
    <div className="document-header">
      <div className="ant-row">
        <div className="ant-col-md-24">
          <H3Text
            text={(
              <span>
                <UserOutlined />
                {' '}
                <span>{`${selectedSO?.internal_cust_code} - ${selectedSO?.customer_info?.customer_name}`}</span>
              </span>
            )}
            className="document-header__party-name"
          />
        </div>
        {selectedSO?.ps_so_details?.sales_order_number
          && Helpers.getPermission(
            Helpers.permissionEntities.SALES_ORDER,
            Helpers.permissionTypes.READ,
            user,
          ) && (
            <div className="ant-col-md-12">
              <div className="document-header__field">
                <H3Text
                  text="SO #"
                  className="document-header__field-name"
                />

                <H3Text
                  text={(
                    <Link
                      to={`/sales/sales-order/view/${selectedSO?.ps_so_details?.order_id}`}
                      target="_blank"
                    >
                      {selectedSO?.ps_so_details
                        ?.sales_order_number || '-'}
                    </Link>
                  )}
                  className="document-header__field-value"
                />
              </div>
            </div>
          )}
        <div className="ant-col-md-12">
          <Tooltip title={selectedSO?.tenant_info?.tenant_name}>
            <div className="document-header__field">
              <H3Text
                text="Location"
                className="document-header__field-name"
              />
              <H3Text
                text={
                  selectedSO?.tenant_info?.tenant_name?.length > 25
                    ? `${selectedSO?.tenant_info?.tenant_name?.slice(
                      0,
                      25,
                    )}...`
                    : selectedSO?.tenant_info?.tenant_name
                }
                className="document-header__field-value"
              />
            </div>
          </Tooltip>
        </div>
        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text
              text="Department"
              className="document-header__field-name"
            />
            <H3Text
              text={
                selectedSO?.tenant_department_info?.department_name
              }
              className="document-header__field-value"
            />
          </div>
        </div>
        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text
              text="Packing Date"
              className="document-header__field-name"
            />
            <H3Text
              text={
                selectedSO?.order_date
                  ? dayjs(selectedSO.order_date).format(
                    'DD/MM/YYYY',
                  )
                  : '-'
              }
              className="document-header__field-value"
            />
          </div>
        </div>
        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text
              text="Vehicle Number"
              className="document-header__field-name"
            />
            <H3Text
              text={selectedSO?.vehicle_number ?? '-'}
              className="document-header__field-value"
            />
          </div>
        </div>
        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text
              text="Remarks"
              className="document-header__field-name"
            />
            <H3Text
              text={selectedSO?.remarks ?? '-'}
              className="document-header__field-value"
            />
          </div>
        </div>
        {selectedSO?.account_manager_info?.first_name && (
          <div className="ant-col-md-12">
            <div className="document-header__field update__account-manager">
              <H3Text
                text="Sales Manager"
                className="document-header__field-name"
              />
              <H3Text
                text={`${selectedSO?.account_manager_info?.first_name || ''
                  } ${selectedSO?.account_manager_info?.last_name || ''
                  }`}
                className="document-header__field-value"
              />
            </div>
          </div>
        )}
        {selectedSO?.custom_fields?.length > 0 ? (
          <ViewCustomFields
            customFields={selectedSO?.custom_fields?.filter(
              (cf) => cf.is_active,
            )}
            wrapperClass="document-header__field"
            labelClass="document-header__field-name"
            valueClass="document-header__field-value"
            inputClassName="document-header__field-input"
            isHorizontal
            isEditable={quickUpdateDisable && hasPsEditAccess}
            handleCustomFieldUpdate={quickUpdateSO}
            entityId={selectedSO.order_id}
            callback={() => {
              const payload = {
                orgId: user?.tenant_info?.org_id,
                tenantId: currentTenantId,
                soId: currentOrderId,
                orderType: salesOrderType,
              };
              getSOById(payload);
            }}
            entityName="order_id"
            entityType="PACKING_SLIP"
          />
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

export default ViewPackingSlipDetails;
